import React from 'react';
import { styled } from '../theming';
import { IconClose, IconMenu } from '../Icon';
import { responsiveProp, ResponsiveProp } from '../utils/responsiveProp';

type StyledToggleProps = {
  flex?: string;
  isVisible: ResponsiveProp<boolean>;
};

const Toggle = styled.a<StyledToggleProps>`
  ${({ flex, isVisible }) => ({
    flex,
    justifyContent: 'flex-end',
    color: 'inherit',
    ...responsiveProp(isVisible, (isVisible) => ({
      display: isVisible ? 'inline-flex' : 'none',
    })),
  })}
`;

export type NavBarToggleProps = {
  flex?: string;
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  isExpanded: boolean;
  labels: {
    open: string;
    close: string;
  };
  // If set, adds a `data-identifier` attribute to the toggle. This can be useful if you need to select the toggle.
  // E.g. if your navbar contains links pointing to elements on the same page, you need to programmatically trigger
  // a click on the toggle to collapse the mobile menu, so that the browser can then scroll down the page to the
  // target element.
  identifier?: string;
};

export const NavBarToggle = ({
  flex,
  onClick,
  isExpanded,
  labels,
  identifier,
}: NavBarToggleProps): JSX.Element => {
  return (
    <Toggle
      href="#"
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        onClick(event);
      }}
      flex={flex}
      isVisible={{ xxxsmall: true, small: false }}
      title={isExpanded ? labels.close : labels.open}
      data-identifier={identifier}
    >
      {isExpanded ? <IconClose /> : <IconMenu />}
    </Toggle>
  );
};
